import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MoreIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PublicIcon from '@mui/icons-material/Public';
import user from '../../../assets/images/default_user.png';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import MobileSidebar from './MobileSidebar';
import logoClosed from '../../../assets/images/logo-light-icon.png';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Person4Icon from '@mui/icons-material/Person4';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: open ? 240 : 80,
  width: `calc(100% - ${open ? 240 : 80}px)`,
}));

const sideBarMenu = ['Dashboard', 'Live Tracking', 'Access control', 'Users / Customer', 'Drivers', 'Sales Report', 'Categories', 'Brands', 'Items', 'Item Attribute', 'Orders', 'Coupons', 'Notifications', 'Payments', 'Banner Items', 'Email Templates', 'CMS Pages', 'Settings'];

export default function TopBar({
  open,
  handleDrawerToggle,
  lan,
  handleChange,
  // handleMobileMenuOpen,
  isMobileMenuOpen,
}) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null); // For controlling the profile menu anchor element
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null); // For controlling the mobile menu anchor element
  const [offopen, offsetOpen] = React.useState(false); // For controlling the mobile sidebar open state

  const menuId = 'primary-search-account-menu';
  const mobileMenuId = 'primary-search-account-menu-mobile';

  // Toggle the mobile sidebar
  const toggleDrawer = (newOpen) => () => {
    offsetOpen(newOpen);
  };
  // Handle logout
  const handleLogout = () => {
    // Remove the authentication token from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');

    // Optionally, show a success message to the user
    toast.success('Logged out successfully!');

    // Redirect to the login page
    navigate('/login');
  };

  // Open profile menu
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Close profile menu
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Open mobile menu
  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget); // This will open the mobile menu
  };

  // Close mobile menu
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const username = localStorage.getItem('username');
  // Render profile menu
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)} // Check if anchorEl is set
      onClose={handleMenuClose}
    >
      <MenuItem sx={{ borderBottom: '1px solid #eeeded' }} onClick={handleMenuClose}>
        <div className='u-img'>
          <img className="menu-user-cls" src={user} alt="" />
        </div>
        <div className="u-text">
          <h4>{username}</h4>
          <p className="text-muted" sx={{ color: ' #99abb4', fontSize: '12px' }}>Super Administrator</p>
        </div>
      </MenuItem>
      <MenuItem  onClick={() => {
        handleMenuClose();
        navigate('/users/profile'); // Using navigate from useNavigate
      }} sx={{ color: '#67757c', padding: '9px 15px', fontWeight: '300', borderBottom: '1px solid #eeeded' }}>
        <Person4Icon sx={{ marginRight: '5px' }} />
        Profile </MenuItem>
      <MenuItem onClick={handleLogout} sx={{ color: '#67757c', padding: '9px 15px', fontWeight: '300' }}>
        <PowerSettingsNewIcon sx={{ marginRight: '5px' }} />Logout</MenuItem>
    </Menu>
  );

  // Render mobile menu
  const renderMobileMenu = (
    // <Menu
    //   anchorEl={mobileMoreAnchorEl}
    //   anchorOrigin={{
    //     vertical: 'top',
    //     horizontal: 'right',
    //   }}
    //   id={mobileMenuId}
    //   keepMounted
    //   transformOrigin={{
    //     vertical: 'top',
    //     horizontal: 'right',
    //   }}
    //   open={Boolean(mobileMoreAnchorEl)} // Use mobileMoreAnchorEl to control visibility
    //   onClose={handleMobileMenuClose}
    // >
    //   <MenuItem>
    //     <IconButton size="large" aria-label="show 17 new notifications" color="inherit">
    //       <Badge badgeContent={17} color="error">
    //         <NotificationsIcon />
    //       </Badge>
    //     </IconButton>
    //     <p>Notifications</p>
    //   </MenuItem>
    //   <MenuItem >
    //     <IconButton
    //       size="large"
    //       aria-label="account of current user"
    //       aria-controls={menuId}
    //       aria-haspopup="true"
    //       color="inherit"
    //     >
    //       <AccountCircle />
    //     </IconButton>
    //     <p>Profile</p>
    //   </MenuItem>
    // </Menu>
    <Menu
    anchorEl={anchorEl}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    id={menuId}
    keepMounted
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    open={Boolean(anchorEl)} // Check if anchorEl is set
    onClose={handleMenuClose}
  >
    <MenuItem sx={{ borderBottom: '1px solid #eeeded' }} onClick={handleMenuClose}>
      <div className='u-img'>
        <img className="menu-user-cls" src={user} alt="" />
      </div>
      <div className="u-text">
        <h4>{username}</h4>
        <p className="text-muted" sx={{ color: ' #99abb4', fontSize: '12px' }}>Super Administrator</p>
      </div>
    </MenuItem>
    <MenuItem  onClick={() => {
      handleMenuClose();
      navigate('/users/profile'); // Using navigate from useNavigate
    }} sx={{ color: '#67757c', padding: '9px 15px', fontWeight: '300', borderBottom: '1px solid #eeeded' }}>
      <Person4Icon sx={{ marginRight: '5px' }} />
      Profile </MenuItem>
    <MenuItem onClick={handleLogout} sx={{ color: '#67757c', padding: '9px 15px', fontWeight: '300' }}>
      <PowerSettingsNewIcon sx={{ marginRight: '5px' }} />Logout</MenuItem>
  </Menu>
  );

  return (
    <AppBar
  position="fixed"
  open={open}
  sx={{
    bgcolor: "#3C7F10",
    width: { xs: "100%", md: `calc(100% - ${open ? 240 : 80}px)` }, // Full width on <=767px, adjusts based on sidebar state
    ml: { xs: "0px", md: `${open ? 240 : 80}px` }, // No margin on <=767px, adjusts based on sidebar state
    zIndex:1,
    paddingRight: { xs: "0px !important", md: "16px !important" }  
  }}
>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        {/* Drawer Toggle Button */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerToggle}
          edge="start"
          sx={[
            { marginRight: 5, marginLeft: 0 },
            open && { display: 'block' },
            {  display:{xs: "none", md: "block" }}
          ]}
        >
          <MenuIcon sx={{ fontSize: 36 }} />
        </IconButton>

        {/* Mobile Hamburger and Drawer */}
        <Box sx={{ display: 'flex' }}>
          <Box component={Link} to={"/"} sx={{ display: { xs: 'block', md: 'none' } }} className={`siderbar-cls ${open ? '' : 'closed'}`}>
            <img src={logoClosed} alt="Logo" />
          </Box>
          <Button className="mobile-hamburger-btn"  sx={{ display: { xs: 'flex', md: 'none' } }} onClick={toggleDrawer(true)}>
            <MenuIcon sx={{ fontSize: 36, color: '#fff' }} />
          </Button>
          <Drawer className="mobile-drawer-cls" sx={{ display: { xs: 'block', md: 'none' } }} open={offopen} onClose={toggleDrawer(false)}>
            <MobileSidebar sideBarMenu={sideBarMenu} handleClose={toggleDrawer(false)}/>
          </Drawer>
        </Box>

        {/* Desktop Notifications and Profile */}
        <div>
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <IconButton size="large" aria-label="show 17 new notifications" color="inherit" sx={{ pr: 3 }}>
              <Badge badgeContent={17} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PublicIcon sx={{ fontSize: 16 }} />
              <FormControl className="language-dropdown-cls" sx={{ m: 1 }}>
                <Select value={lan} onChange={handleChange} displayEmpty inputProps={{ 'aria-label': 'Without label' }}>
                  <MenuItem value="">English</MenuItem>
                  <MenuItem value={20}>Arabic</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <img className="user-cls" src={user} alt="" />
            </IconButton>
          </Box>

          {/* Mobile Menu Icon */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </div>
      </Toolbar>

      {/* Profile and Mobile Menus */}
      {renderMenu}
      {renderMobileMenu}
    </AppBar>
  );
}
